import { enumStaticTextType } from "../constants";
import { Globals } from "../CoreApp/Globals";
import { QLinkText } from "../CoreApp/QLinkText";

export function AddLinkText(
  parent,
  xPos,
  yPos,
  cmdCode,
  label,
  fontSize,
  bold,
  fontColor,
  availableWidth
) {
  var newLink = new QLinkText();
  const gPanelThemeMode = Globals._themeMode;
  newLink.InitLinkText(cmdCode, fontColor == null ? gPanelThemeMode.text.body : fontColor);
  newLink.SetBold(bold);
  newLink.SetItalic(false);
  newLink.SetLabel(label);
  newLink.SetAlignment("left");
  newLink.SetTextColor(parent.fUIColors ? parent.fUIColors.GetLinkTextBlueColor() : fontColor);
  newLink.SetFontSize(fontSize);
  newLink.SetFontName("Arial");
  newLink.PositionElement(xPos, yPos);
  if (availableWidth != null) {
    newLink.SetAvailableWidth(availableWidth);
    newLink.SetSizingMode(enumStaticTextType.multiline);
  }
  newLink.AutoSize();
  newLink.fParentPanel = parent;
  parent.PushElement(newLink);
  return newLink;
}
